import React from 'react';
import { StorySection } from '../components/StorySection';
import { MusicIcon, WineIcon, CrownIcon, CloudIcon, UtensilsIcon, SparklesIcon, ShirtIcon, StarIcon, CarIcon } from 'lucide-react';
export function Experience() {
  return <main className="bg-matte" data-id="element-193">
      {/* Hero Banner */}
      <section className="relative h-[50vh] min-h-[400px] flex items-center justify-center overflow-hidden" data-id="element-194">
        <div className="absolute inset-0 z-0" style={{
        backgroundImage: `linear-gradient(to bottom, rgba(0,0,0,0.4), rgba(0,0,0,0.9)), url('https://images.unsplash.com/photo-1574096079513-a8225ba06814?w=1920&q=80')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }} data-id="element-195" />
        <div className="relative z-10 text-center px-6 mt-16 fade-section" data-id="element-196">
          <h1 className="font-serif text-[50px] md:text-[62px] lg:text-[74px] text-white mb-6" data-id="element-197">
            THE EXPERIENCE
          </h1>
          <div className="w-24 h-px bg-gold mx-auto mb-6" data-id="element-198" />
          <p className="font-sans text-lg md:text-xl text-white/80 max-w-2xl mx-auto tracking-wide" data-id="element-199">
            From dinner to the dance floor — one seamless evening
          </p>
        </div>
      </section>

      {/* Section 1: The Evening Unfolds (Timeline) */}
      <section className="py-28 px-6 bg-matte fade-section" data-id="element-200">
        <div className="max-w-4xl mx-auto" data-id="element-201">
          <div className="text-center mb-20" data-id="element-202">
            <h2 className="font-sans text-sm tracking-mega-wide text-gold uppercase mb-4" data-id="element-203">
              The Journey
            </h2>
            <h3 className="font-serif text-[38px] md:text-[50px] text-white" data-id="element-204">
              THE EVENING UNFOLDS
            </h3>
          </div>

          <div className="relative border-l border-gold/30 ml-4 md:ml-1/2 md:left-1/2 md:-translate-x-1/2 space-y-16 md:space-y-24" data-id="element-205">
            {/* Step 1 */}
            <div className="relative pl-12 md:pl-0 md:flex md:items-center md:justify-between group" data-id="element-206">
              <div className="absolute left-[-17px] md:left-1/2 md:-translate-x-1/2 top-0 w-8 h-8 bg-matte border-2 border-gold rounded-full flex items-center justify-center z-10 group-hover:bg-gold transition-colors duration-300" data-id="element-207">
                <span className="font-serif text-sm text-gold group-hover:text-black" data-id="element-208">
                  1
                </span>
              </div>
              <div className="md:w-5/12 md:text-right md:pr-12" data-id="element-209">
                <h4 className="font-serif text-[26px] md:text-[32px] text-white mb-2" data-id="element-210">
                  The Welcome
                </h4>
                <span className="font-sans text-sm tracking-widest text-gold uppercase block mb-4" data-id="element-211">
                  6:00 PM - 8:00 PM
                </span>
              </div>
              <div className="md:w-5/12 md:pl-12" data-id="element-212">
                <p className="font-sans text-lg text-white/60 leading-relaxed" data-id="element-213">
                  Arrive, be seated, and explore the menu. Warm lighting and an
                  intimate atmosphere set the stage for the night ahead.
                </p>
              </div>
            </div>

            {/* Step 2 */}
            <div className="relative pl-12 md:pl-0 md:flex md:items-center md:justify-between md:flex-row-reverse group" data-id="element-214">
              <div className="absolute left-[-17px] md:left-1/2 md:-translate-x-1/2 top-0 w-8 h-8 bg-matte border-2 border-gold rounded-full flex items-center justify-center z-10 group-hover:bg-gold transition-colors duration-300" data-id="element-215">
                <span className="font-serif text-sm text-gold group-hover:text-black" data-id="element-216">
                  2
                </span>
              </div>
              <div className="md:w-5/12 md:text-left md:pl-12" data-id="element-217">
                <h4 className="font-serif text-[26px] md:text-[32px] text-white mb-2" data-id="element-218">
                  The Feast
                </h4>
                <span className="font-sans text-sm tracking-widest text-gold uppercase block mb-4" data-id="element-219">
                  8:00 PM - 10:00 PM
                </span>
              </div>
              <div className="md:w-5/12 md:text-right md:pr-12" data-id="element-220">
                <p className="font-sans text-lg text-white/60 leading-relaxed" data-id="element-221">
                  Savor authentic West African cuisine. From smoky Jollof to
                  perfectly spiced Suya, every dish tells a story of heritage
                  and flavor.
                </p>
              </div>
            </div>

            {/* Step 3 */}
            <div className="relative pl-12 md:pl-0 md:flex md:items-center md:justify-between group" data-id="element-222">
              <div className="absolute left-[-17px] md:left-1/2 md:-translate-x-1/2 top-0 w-8 h-8 bg-matte border-2 border-gold rounded-full flex items-center justify-center z-10 group-hover:bg-gold transition-colors duration-300" data-id="element-223">
                <span className="font-serif text-sm text-gold group-hover:text-black" data-id="element-224">
                  3
                </span>
              </div>
              <div className="md:w-5/12 md:text-right md:pr-12" data-id="element-225">
                <h4 className="font-serif text-[26px] md:text-[32px] text-white mb-2" data-id="element-226">
                  The Lounge
                </h4>
                <span className="font-sans text-sm tracking-widest text-gold uppercase block mb-4" data-id="element-227">
                  10:00 PM - 2:00 AM
                </span>
              </div>
              <div className="md:w-5/12 md:pl-12" data-id="element-228">
                <p className="font-sans text-lg text-white/60 leading-relaxed" data-id="element-229">
                  The lights dim, the DJ takes over. Afrobeats, premium
                  cocktails, and pure energy transform the space into a vibrant
                  nightlife destination.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Section 2: The Lounge (Emphasis) */}
      <section className="py-28 px-0 bg-charcoal fade-section" data-id="element-230">
        <div className="grid grid-cols-1 md:grid-cols-5 min-h-[600px]" data-id="element-231">
          {/* Content Side (Left, 40%) */}
          <div className="md:col-span-2 bg-charcoal p-12 md:p-16 lg:p-24 flex flex-col justify-center order-2 md:order-1" data-id="element-232">
            <span className="font-sans text-sm tracking-mega-wide text-gold uppercase mb-2" data-id="element-233">
              After Dark
            </span>
            <h2 className="font-serif text-[38px] md:text-[50px] text-white mb-8" data-id="element-234">
              THE LOUNGE
            </h2>
            <p className="font-sans text-lg text-white/70 leading-relaxed mb-12" data-id="element-235">
              When dinner concludes, Tempoo truly comes alive. Our resident DJs
              spin the best of Afrobeats, Amapiano, and Hip-Hop every Friday and
              Saturday night. Experience premium bottle service, exclusive VIP
              sections, and an LED-lit ambiance that rivals the city's top
              clubs—all without leaving your seat.
            </p>

            {/* Mini Grid */}
            <div className="grid grid-cols-2 gap-8" data-id="element-236">
              <div className="flex items-start gap-4" data-id="element-237">
                <MusicIcon className="w-6 h-6 text-gold flex-shrink-0 mt-1" data-id="element-238" />
                <div data-id="element-239">
                  <h5 className="font-sans text-base text-white font-medium mb-1" data-id="element-240">
                    Live DJ
                  </h5>
                  <p className="font-sans text-sm text-white/50" data-id="element-241">
                    Afrobeats & Amapiano
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-4" data-id="element-242">
                <WineIcon className="w-6 h-6 text-gold flex-shrink-0 mt-1" data-id="element-243" />
                <div data-id="element-244">
                  <h5 className="font-sans text-base text-white font-medium mb-1" data-id="element-245">
                    Bottle Service
                  </h5>
                  <p className="font-sans text-sm text-white/50" data-id="element-246">
                    Premium spirits
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-4" data-id="element-247">
                <CrownIcon className="w-6 h-6 text-gold flex-shrink-0 mt-1" data-id="element-248" />
                <div data-id="element-249">
                  <h5 className="font-sans text-base text-white font-medium mb-1" data-id="element-250">
                    VIP Sections
                  </h5>
                  <p className="font-sans text-sm text-white/50" data-id="element-251">
                    Exclusive seating
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-4" data-id="element-252">
                <CloudIcon className="w-6 h-6 text-gold flex-shrink-0 mt-1" data-id="element-253" />
                <div data-id="element-254">
                  <h5 className="font-sans text-base text-white font-medium mb-1" data-id="element-255">
                    Hookah
                  </h5>
                  <p className="font-sans text-sm text-white/50" data-id="element-256">
                    Premium flavors
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Image Side (Right, 60%) */}
          <div className="md:col-span-3 h-[500px] md:h-auto relative order-1 md:order-2" data-id="element-257">
            <img src="https://images.unsplash.com/photo-1516997121675-4c2d1684aa3e?w=1200&q=80" alt="Tempoo Lounge Nightlife" className="w-full h-full object-cover" data-id="element-258" />
            <div className="absolute inset-0 bg-gradient-to-r from-charcoal via-transparent to-transparent hidden md:block" data-id="element-259" />
          </div>
        </div>
      </section>

      {/* Section 3: Floor Plan & Reservations */}
      <section className="py-28 px-6 bg-matte fade-section" data-id="element-260">
        <div className="max-w-7xl mx-auto" data-id="element-261">
          <div className="text-center mb-16" data-id="element-262">
            <h2 className="font-sans text-sm tracking-mega-wide text-gold uppercase mb-4" data-id="element-263">
              Choose Your Experience
            </h2>
            <h3 className="font-serif text-[38px] md:text-[50px] text-white" data-id="element-264">
              RESERVE YOUR SPOT
            </h3>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-265">
            {/* Card 1: Main Dining */}
            <div className="bg-charcoal border border-white/5 p-8 md:p-10 flex flex-col h-full group hover:border-white/20 transition-colors duration-300" data-id="element-266">
              <UtensilsIcon className="w-8 h-8 text-gold mb-6" data-id="element-267" />
              <h4 className="font-serif text-[26px] text-white mb-4" data-id="element-268">
                Main Dining
              </h4>
              <p className="font-sans text-lg text-white/60 mb-8 flex-grow" data-id="element-269">
                Intimate tables for 2-6 guests. Perfect for a dinner date or
                small gathering to enjoy our West African menu.
              </p>
              <div className="space-y-2 mb-8" data-id="element-270">
                <p className="font-sans text-sm text-white/80 flex justify-between border-b border-white/10 pb-2" data-id="element-271">
                  <span data-id="element-272">Capacity</span>
                  <span className="text-gold" data-id="element-273">Up to 6 guests</span>
                </p>
                <p className="font-sans text-sm text-white/80 flex justify-between pt-2" data-id="element-274">
                  <span data-id="element-275">Pricing</span>
                  <span className="text-gold" data-id="element-276">No minimum spend</span>
                </p>
              </div>
              <a href="tel:2405359729" className="w-full text-center border border-gold text-gold px-6 py-3 font-sans uppercase tracking-widest text-sm font-medium hover:bg-gold/10 transition-all duration-300" data-id="element-277">
                Reserve a Table
              </a>
            </div>

            {/* Card 2: VIP Booth */}
            <div className="bg-charcoal border border-gold/30 p-8 md:p-10 flex flex-col h-full relative overflow-hidden group hover:border-gold transition-colors duration-300" data-id="element-278">
              <div className="absolute top-0 right-0 bg-gold text-black font-sans text-xs uppercase tracking-widest px-4 py-1 font-bold" data-id="element-279">
                Popular
              </div>
              <CrownIcon className="w-8 h-8 text-gold mb-6" data-id="element-280" />
              <h4 className="font-serif text-[26px] text-white mb-4" data-id="element-281">
                VIP Booth
              </h4>
              <p className="font-sans text-lg text-white/60 mb-8 flex-grow" data-id="element-282">
                Premium booth seating with dedicated service. The best view of
                the lounge. Bottle packages available.
              </p>
              <div className="space-y-2 mb-8" data-id="element-283">
                <p className="font-sans text-sm text-white/80 flex justify-between border-b border-white/10 pb-2" data-id="element-284">
                  <span data-id="element-285">Capacity</span>
                  <span className="text-gold" data-id="element-286">Up to 10 guests</span>
                </p>
                <p className="font-sans text-sm text-white/80 flex justify-between pt-2" data-id="element-287">
                  <span data-id="element-288">Pricing</span>
                  <span className="text-gold" data-id="element-289">From $500 minimum</span>
                </p>
              </div>
              <a href="tel:2405359729" className="w-full text-center bg-gold/10 border border-gold text-gold px-6 py-3 font-sans uppercase tracking-widest text-sm font-medium hover:bg-gold hover:text-black transition-all duration-300" data-id="element-290">
                Book VIP
              </a>
            </div>

            {/* Card 3: Full Venue */}
            <div className="bg-charcoal border border-white/5 p-8 md:p-10 flex flex-col h-full group hover:border-white/20 transition-colors duration-300" data-id="element-291">
              <SparklesIcon className="w-8 h-8 text-gold mb-6" data-id="element-292" />
              <h4 className="font-serif text-[26px] text-white mb-4" data-id="element-293">
                Full Venue
              </h4>
              <p className="font-sans text-lg text-white/60 mb-8 flex-grow" data-id="element-294">
                Private buyout for corporate events, birthdays, and large
                celebrations. Custom menus and entertainment.
              </p>
              <div className="space-y-2 mb-8" data-id="element-295">
                <p className="font-sans text-sm text-white/80 flex justify-between border-b border-white/10 pb-2" data-id="element-296">
                  <span data-id="element-297">Capacity</span>
                  <span className="text-gold" data-id="element-298">Up to 150 guests</span>
                </p>
                <p className="font-sans text-sm text-white/80 flex justify-between pt-2" data-id="element-299">
                  <span data-id="element-300">Pricing</span>
                  <span className="text-gold" data-id="element-301">Custom pricing</span>
                </p>
              </div>
              <a href="tel:2405359729" className="w-full text-center border border-gold text-gold px-6 py-3 font-sans uppercase tracking-widest text-sm font-medium hover:bg-gold/10 transition-all duration-300" data-id="element-302">
                Inquire Now
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Section 4: What to Expect */}
      <section className="py-28 px-6 bg-charcoal fade-section" data-id="element-303">
        <div className="max-w-7xl mx-auto" data-id="element-304">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12" data-id="element-305">
            <div className="text-center flex flex-col items-center" data-id="element-306">
              <ShirtIcon className="w-10 h-10 text-gold mb-6" data-id="element-307" />
              <h4 className="font-serif text-[26px] text-white mb-4" data-id="element-308">
                Dress Code
              </h4>
              <p className="font-sans text-base text-white/60" data-id="element-309">
                Sophisticated attire. No athletic wear, hats, or work boots.
                Dress to impress.
              </p>
            </div>
            <div className="text-center flex flex-col items-center" data-id="element-310">
              <MusicIcon className="w-10 h-10 text-gold mb-6" data-id="element-311" />
              <h4 className="font-serif text-[26px] text-white mb-4" data-id="element-312">Music</h4>
              <p className="font-sans text-base text-white/60" data-id="element-313">
                Afrobeats, Amapiano, R&B, and Hip-Hop. Live DJ every Friday &
                Saturday night.
              </p>
            </div>
            <div className="text-center flex flex-col items-center" data-id="element-314">
              <StarIcon className="w-10 h-10 text-gold mb-6" data-id="element-315" />
              <h4 className="font-serif text-[26px] text-white mb-4" data-id="element-316">
                Service
              </h4>
              <p className="font-sans text-base text-white/60" data-id="element-317">
                Attentive, personalized service. Your server knows the West
                African menu inside out.
              </p>
            </div>
            <div className="text-center flex flex-col items-center" data-id="element-318">
              <CarIcon className="w-10 h-10 text-gold mb-6" data-id="element-319" />
              <h4 className="font-serif text-[26px] text-white mb-4" data-id="element-320">
                Parking
              </h4>
              <p className="font-sans text-base text-white/60" data-id="element-321">
                Free parking available in the plaza lot. Valet service available
                on weekends.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Story Section */}
      <StorySection data-id="element-322" />
    </main>;
}